import { MutableRefObject, useCallback, useEffect, useRef } from 'react';

export function useForceCookieLabel<T>(
  label: string,
  condition: boolean = true
): MutableRefObject<T> {
  const cookieButtonRef = useRef<T extends HTMLElement ? T : never>();
  const iid = useRef<NodeJS.Timer>();

  const checkIfLoaded: (v: string) => boolean = useCallback((v) => {
    return v.length > 0;
  }, []);

  useEffect(() => {
    if (!condition) return;
    iid.current = setInterval(() => {
      if (!checkIfLoaded(cookieButtonRef.current.innerHTML)) return;
      cookieButtonRef.current.innerHTML = label;
      clearInterval(iid.current);
    }, 10);
  }, []);

  return cookieButtonRef;
}
